<div class="pr">
  <div *ngIf="showCustomView" class="block customize-view-panel">
    <div class="dblock bold customize-view-header">Customize view<button title="Cancel" (click)="hideCustomView()" class="customize-view-close-btn"><i class="material-icons clear">clear</i></button></div>
    <div class="dblock">
      <div class="block bold">Data grouping</div>
      <div class="data-grouping-row">
        <div class="data-grouping-section">
          <div class="block toggle-row">Positions
            <span class="toggle-spacer">
              <mat-slide-toggle [checked]="config.showPositions" (change)="config.showPositions = !config.showPositions; onInputChange()" [disabled]="false"></mat-slide-toggle>
            </span>
          </div>
        </div>
        <div class="data-grouping-section">
          <div class="block">Schwab Asset Classes
            <span class="toggle-spacer">
              <mat-slide-toggle [checked]="config.showSAC" (change)="config.showSAC = !config.showSAC; onInputChange()" [disabled]="false"></mat-slide-toggle>
            </span>
          </div>
          <div>
            <span class="checkbox-spacer">Asset Class Detail</span>
            <span class="checkbox-spacer"><input type="checkbox" [ngModel]="config.showSACLevel1" (change)="config.showSACLevel1 = !config.showSACLevel1; onInputChange()"/> Level 1</span>
            <span class="checkbox-spacer"><input type="checkbox" [ngModel]="config.showSACLevel2" (change)="config.showSACLevel2 = !config.showSACLevel2; onInputChange()"/> Level 2</span>
            <span class="checkbox-spacer"><input type="checkbox" [ngModel]="config.showSACLevel3" (change)="config.showSACLevel3 = !config.showSACLevel3; onInputChange()"/> Level 3</span>
            <span class="checkbox-spacer"><input type="checkbox" [ngModel]="config.showSACLevel4" (change)="config.showSACLevel4 = !config.showSACLevel4; onInputChange()"/> Level 4</span>
          </div>
        </div>
        <div class="data-grouping-section">
          <div>{{categoryLabel}} (User Editable)
            <span class="toggle-spacer">
              <mat-slide-toggle [checked]="config.showCustCat" (change)="config.showCustCat = !config.showCustCat; onInputChange()" [disabled]="false"></mat-slide-toggle>
            </span>
          </div>
        </div>
        <div class="data-grouping-section-last">
          <div>Morningstar Stock Style
            <span class="toggle-spacer">
              <mat-slide-toggle [checked]="config.showMorningstarStockStyles" (change)="config.showMorningstarStockStyles = !config.showMorningstarStockStyles; onInputChange()" [disabled]="false"></mat-slide-toggle>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="block bold">Chart style</div>
      <div>View as
        <span class="chart-style-dropdown"><irb-dropdown-filter #chartStyleDropdown
                [(value)]="chartStyle"
                (search)="setChartStyleDropdown($event)"
                size="15" hoverPanelWidth="150"
                (valueChange)="onChartStyleChange();"></irb-dropdown-filter></span>
      </div>
    </div>
  </div>
  <div class="block expand-collapse-links">
    <span><a (click)="expandAll()">Expand all</a></span>
    <span class="collapse-link"><a (click)="collapseAll()">Collapse all</a></span>
  </div>

  <irb-model-allocation-chart-group *ngIf="config.showPositions" [expanded]="expanded.POSITION" (expandedChange)="expanded.POSITION = !expanded.POSITION; onInputChange()" title="Positions" groupBy="POSITION" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config"></irb-model-allocation-chart-group>

  <div class="sac-group-container" *ngIf="config.showSAC">
    <div>
      <i class="pi pi-chevron-down clickable sac-chevron" *ngIf="!expanded.SAC" (click)="expanded.SAC = !expanded.SAC; onInputChange()"></i>
      <i class="pi pi-chevron-up clickable sac-chevron" *ngIf="expanded.SAC" (click)="expanded.SAC = !expanded.SAC; onInputChange()"></i>
    </div>
    <div class="sac-content">
      <div class="block bold sac-group-title">Schwab Asset Classes</div>
      <div *ngIf="expanded.SAC">
        <irb-model-allocation-chart-group *ngIf="config.showSACLevel1" subTitle="Level 1" groupBy="SAC1" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config" [expanded]="true"></irb-model-allocation-chart-group>

        <irb-model-allocation-chart-group *ngIf="config.showSACLevel2" subTitle="Level 2" groupBy="SAC2" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config" [expanded]="true"></irb-model-allocation-chart-group>

        <irb-model-allocation-chart-group *ngIf="config.showSACLevel3" subTitle="Level 3" groupBy="SAC3" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config" [expanded]="true"></irb-model-allocation-chart-group>

        <irb-model-allocation-chart-group *ngIf="config.showSACLevel4" subTitle="Level 4" groupBy="SAC4" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config" [expanded]="true"></irb-model-allocation-chart-group>
      </div>
    </div>
  </div>

  <irb-model-allocation-chart-group *ngIf="config.showCustCat" [expanded]="expanded.CUST_CAT" (expandedChange)="expanded.CUST_CAT = !expanded.CUST_CAT; onInputChange()" title="{{categoryLabel}}" groupBy="CUST_CAT" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config"></irb-model-allocation-chart-group>

  <irb-model-allocation-chart-group *ngIf="config.showMorningstarStockStyles" [expanded]="expanded.MSS" (expandedChange)="expanded.MSS = !expanded.MSS; onInputChange()" title="Morningstar Stock Styles" groupBy="MSS" [modelType]="modelType" [noTarget]="noTarget" [categoryLabel]="categoryLabel" [config]="config"></irb-model-allocation-chart-group>
</div>



